module.exports = __webpack_public_path__ + "static/img/021.83231e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/021.png
// module id = qpB1
// module chunks = 1